export enum RepositoriesTypesUnavailableService {
  SET_UNAVAILABLE_SERVICE = '@repositories/SET_UNAVAILABLE_SERVICE',
}
export interface IRepositoriesStateUnavailableService {
  readonly isUnavailableService: boolean | null;
}
